//Vendor
import axios from 'axios'
import gsap from 'gsap'
//Custom
import Page from 'Scripts/classes/Page'
import { getFile, getDocURL } from 'Scripts/utils/wordpress'
import { formatSizeUnits } from 'Scripts/utils/utils'
import { getDocTerm } from '../utils/wordpress'
import { getCookieValue } from '../utils/utils'

export default class extends Page {
  constructor() {
    super('document', {
      container: '.documents',
      elements: {
        paginationLink: '.module__btn_readmore a',
        moduleWrapper: '.module__wrapper',
        date: '.dropdown .dropdown__input_hidden[name="date"]',
        category: '.dropdown .dropdown__input_hidden[name="category"]',
        filterInput: '.dropdown .dropdown__input_hidden',
      },
    })
    //Language
    this.lang = getCookieValue('wp-wpml_current_language') || 'fr'
    // this.tl = gsap.timeline()
    //Method
    this.filterDocuments()
    this.initProtectedLink()
  }

  filterDocuments() {
    this.elements.filterInput.forEach((input) => {
      input.addEventListener('change', () => {
        // console.log('filterDocuments : ', {
        //   category: this.elements.category.value,
        //   date: this.elements.date.value,
        // })
        this.getDocuments({
          category: this.elements.category.value,
          date: this.elements.date.value,
        })
      })
    })
  }

  async getDocuments(filters) {
    //Retrieve data
    // const { data } = await axios.get(
    //   `${process.env.API}/documents?orderby=date&order=${filters.date}&per_page=100`
    // )

    const { data } = await axios({
      method: 'get',
      url: `${process.env.SGTMAPI}/proxy`,
      params: {
        endpoint: 'documents',
        orderby: 'date',
        order: filters.date,
        lang: this.lang,
        per_page: 100,
      },
    })

    // console.log(`${process.env.API}/documents?orderby=date&order=${filters.date}&per_page=100`)
    const newData = filters.category
      ? data.filter((item) => item.document_cat.indexOf(parseInt(filters.category)) !== -1)
      : data
    const length = newData.length
    const documents = await this.Layout(newData)
    //update HTML

    this.elements.paginationLink.dataset.count = length
    this.elements.paginationLink.dataset.page = 1
    this.elements.moduleWrapper.innerHTML = documents
    if (this.elements.paginationLink.dataset.perpage >= length) {
      this.elements.paginationLink.classList.add('is__hidden')
    } else {
      this.elements.paginationLink.classList.remove('is__hidden')
    }

    //Reinit components
    this.initProtectedLink()
    this.initPagination()
    this.show()
    this.emitEvent()
  }

  async Layout(data) {
    const layout = await Promise.all(
      data.map(async (item) => {
        const file = await getFile(item.acf.fichier)
        const term = item.document_cat && (await getDocTerm(item.document_cat[0]))

        const modalHTML = `<div class="password__modal">
                            <h5 class="with__icon" > 
                              <span>
                                <svg width="12.353" height="15">
                                  <path
                                    d="M11.294 5.294H9.706V4.059C9.706 1.503 8.528 0 6.176 0S2.647 1.5 2.647 4.059v1.235H.882A1.05 1.05 0 0 0 0 6.353v6.882a1.294 1.294 0 0 0 .84 1.153l1.056.34a6.748 6.748 0 0 0 1.722.271h5.118a6.748 6.748 0 0 0 1.722-.271l1.056-.34a1.294 1.294 0 0 0 .84-1.153V6.353a1.213 1.213 0 0 0-1.06-1.059ZM4.411 3.706a1.773 1.773 0 1 1 3.53 0v1.588h-3.53Z"
                                    fill="#fff" />
                                </svg>
                              </span>
                              <span>Accès sécurisé</span>
                            </h5>
                            <h6>Renseignez le mot de passe pour télécharger ce document</h6>
                            <div class="password__modal_form"> 
                              <input type="password" data-id="${item.id}"/>
                              <div class="password__modal_submit">
                                <svg width="12.353" height="15">
                                  <path
                                    d="M11.294 5.294H9.706V4.059C9.706 1.503 8.528 0 6.176 0S2.647 1.5 2.647 4.059v1.235H.882A1.05 1.05 0 0 0 0 6.353v6.882a1.294 1.294 0 0 0 .84 1.153l1.056.34a6.748 6.748 0 0 0 1.722.271h5.118a6.748 6.748 0 0 0 1.722-.271l1.056-.34a1.294 1.294 0 0 0 .84-1.153V6.353a1.213 1.213 0 0 0-1.06-1.059ZM4.411 3.706a1.773 1.773 0 1 1 3.53 0v1.588h-3.53Z"
                                    fill="#fff" />
                                </svg>
                              </div>
                            </div>
                          <small></small>
                        </div>`

        return ` <div class="module__item is__hidden" data-animation="reveal">
                <div class="container">
                  <div class="dis__grid">
                    <div>
                      <h6>${term}</h6>  
                      <h4 class="module__item_title">${item.title.rendered}</h4>
                    </div>
                    <div class="dis__flex pos__relative">
                      <div class="module__item_meta">.${file.type.slice(-3)} / ${formatSizeUnits(
          file.size
        )}</div>
                      <a class="button__outline ${
                        item.content.protected ? 'with__icon protected' : ''
                      }" href="${item.content.protected ? '' : file.link}" data-id="${
          item.id
        }" data-transition-prevent="self" target="_blank"> 
                        <span>Télécharger</span>
                        ${
                          item.content.protected
                            ? '<span class="cadenas"><svg xmlns="http://www.w3.org/2000/svg" width="12.353" height="15"><path d="M11.294 5.294H9.706V4.059C9.706 1.503 8.528 0 6.176 0S2.647 1.5 2.647 4.059v1.235H.882A1.05 1.05 0 0 0 0 6.353v6.882a1.294 1.294 0 0 0 .84 1.153l1.056.34a6.748 6.748 0 0 0 1.722.271h5.118a6.748 6.748 0 0 0 1.722-.271l1.056-.34a1.294 1.294 0 0 0 .84-1.153V6.353a1.213 1.213 0 0 0-1.06-1.059ZM4.411 3.706a1.773 1.773 0 1 1 3.53 0v1.588h-3.53Z" fill="#fff"/></svg></span> '
                            : ''
                        }                     
                      </a>
                      ${item.content.protected ? modalHTML : ''}
                    </div>
                    <h5 class="module__item_descriptif">${item.acf.descriptif}</h5>
                  </div >
                </div >
              </div > `
      })
    )

    return layout.join('')
  }

  initProtectedLink() {
    gsap.utils
      .toArray('.protected')
      .forEach((link) => link.addEventListener('click', this.onClick.bind(this), false))
    gsap.utils
      .toArray('.password__modal_form')
      .forEach((input) => input.addEventListener('keypress', this.onKeyPress.bind(this), false))
    gsap.utils
      .toArray('.password__modal_submit')
      .forEach((input) =>
        input.addEventListener(
          'click',
          (event) =>
            this.getProtectedlink(event.target.closest('.password__modal_form').firstElementChild),
          false
        )
      )
    gsap.utils
      .toArray('.module__item')
      .forEach((item) => item.addEventListener('mouseleave', this.onMouseleave.bind(this), false))
  }

  onMouseleave(event) {
    const modal = event.target.querySelector('.password__modal')
    const button = event.target.querySelector('.protected')
    if (!modal) return

    if (button.classList.contains('is__active')) {
      button.classList.remove('is__active')
      gsap.to(modal, {
        autoAlpha: 0,
        duration: 0.5,
        ease: 'Power2.in',
      })
    }
  }

  onClick(event) {
    event.preventDefault()

    if (event.target.classList.contains('is__active')) {
      event.target.classList.remove('is__active')
      gsap.to(event.target.nextElementSibling, {
        autoAlpha: 0,
        duration: 0.5,
        ease: 'Power2.in',
      })
    } else {
      event.target.classList.add('is__active')
      gsap.to(event.target.nextElementSibling, {
        autoAlpha: 1,
        duration: 1,
        ease: 'Power2.out',
      })
    }
  }

  onKeyPress(event) {
    if (event.key === 'Enter') {
      this.getProtectedlink(event.target)
    }
  }

  async getProtectedlink(target) {
    const modal = target.closest('.password__modal')
    if (target.value == '') {
      modal.querySelector('small').innerHTML = 'Veuillez saisir le mot de passe'
    } else {
      const response = await getDocURL('documents', target.dataset.id, target.value)
      if (response === 403) {
        modal.querySelector('small').innerHTML = 'Mot de passe incorrect'
      } else {
        modal.querySelector('small').innerHTML = ''
        const file = await getFile(response.data.acf.fichier)
        window.open(file.link, '_blank')

        gsap.to(modal, {
          autoAlpha: 0,
          duration: 1,
          ease: 'Power2.out',
        })
      }
    }
  }

  emitEvent() {
    window.dispatchEvent(new Event('resize'))
  }

  /**
   * Animations.
   */
  show() {
    return super.show()
  }

  hide() {
    return super.hide()
  }

  onResize() {
    // console.log('Documents onResize event')
    return super.onResize()
  }
}
